import { z } from "zod"

export const ProductSchema = z.object({
  id: z.number(),
  name: z.string(),
  website: z.string().nullish(),
  is_tracked: z.boolean(),
})

export type Product = z.infer<typeof ProductSchema>
